Controller.$inject = [];

function Controller() {

}

export function HuiMenuFooter() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                 <div class="hui hui-menu-footer" ng-transclude></div>
            `;
        }
    }
}